class OptionsEditor {

  constructor(configuration) {

    this.fieldRow = configuration.fieldRow;
    this.onChange = configuration.onChange;

  }

  propogateFieldOptionsChange() {

    this.onChange(this.fieldRow.options);

  }

}

export default OptionsEditor;